import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_CONTACT,
  DELETE_CONTACT,
  UPDATE_CONTACT,
  ADD_NEW_CONTACT,
} from "./actionType";

import {
  getContactSuccess,
  getContactFail,
  deleteContactSuccess,
  deleteContactFail,
  updateContactSuccess,
  updateContactFail,
  addContactSuccess,
  addContactFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveContactApi,
  getContactApi,
  updateContactApi,
  deleteContactApi,
  addNewContactApi,
} from "../../helpers/backend_helper";

function* getContact({ payload: contact }) {
  try {
    const response = yield call(getContactApi, contact);
    yield put(getContactSuccess(GET_CONTACT, response.data));
  } catch (error) {
    yield put(getContactFail(GET_CONTACT, error));
  }
}

function* onUpdateContact({ payload: contact }) {
  try {
    if (contact.setApprove) {
      const response = yield call(approveContactApi, contact);
      yield put(updateContactSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateContactApi, contact);
      yield put(updateContactSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteContact({ payload: contact }) {
  try {
    const response = yield call(deleteContactApi, contact);
    yield put(deleteContactSuccess({ contact, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewContact({ payload: contact }) {
  try {
    const response = yield call(addNewContactApi, contact);
    yield put(addContactSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetContact() {
  yield takeEvery(GET_CONTACT, getContact);
}

export function* watchUpdateContact() {
  yield takeEvery(UPDATE_CONTACT, onUpdateContact);
}

export function* watchDeleteContact() {
  yield takeEvery(DELETE_CONTACT, onDeleteContact);
}

export function* watchAddNewContact() {
  yield takeEvery(ADD_NEW_CONTACT, onAddNewContact);
}

function* contactSaga() {
  yield all([
    fork(watchGetContact),
    fork(watchDeleteContact),
    fork(watchUpdateContact),
    fork(watchAddNewContact),
  ]);
}

export default contactSaga;
